import { createSlice } from '@reduxjs/toolkit'
import asyncCurrentUser from '../thunks/user/asyncCurrentUser';

const initialState = {
    name: "Загрузка...",
    uuid: null
}

const userSlice = createSlice({
    name: 'user',
    initialState,
    extraReducers: builder => {
        // Async user
        builder.addCase(asyncCurrentUser.fulfilled, (state, action) => {
            state.uuid = action.payload.data.uuid;
            state.name = action.payload.data.name;
        });
    }
});

export const { setUserName } = userSlice.actions;
export default userSlice.reducer;